// Runtime configuration.
//
// Both values are public by nature — they ship in the client bundle either
// way — but only PUBLIC_-prefixed vars are exposed to browser code, so nothing
// else in the environment can leak into it by accident.
//
// The same `process.env.PUBLIC_*` expression resolves in both modes:
//   • dev   — Bun inlines vars matching the prefix in bunfig.toml
//   • build — build.ts substitutes them via `define`
//
// Set them in .env.local locally, and in the Vercel project settings for
// production. An empty Clerk key makes the app fall back to NoAuthRoutes,
// which silently hides all sign-in UI — see App.tsx.

export const config = {
  googleMapsApiKey: process.env.PUBLIC_GOOGLE_MAPS_API_KEY ?? "",
  clerkPublishableKey: process.env.PUBLIC_CLERK_PUBLISHABLE_KEY ?? "",
};
